import React, { useEffect, useState } from "react";
import apiClient from "../../../../../../../Config/apiClient";
import { ClipLoader } from "react-spinners";
import { showErrorToast } from "../../../../../../../Context/Toaster/Toaster";
import CalenderIcon from "../../../../../../../Assets/images/calendar-icon.svg";
import moment from "moment";
import { DATE_FORMAT } from "../../../../Utils/Constants";

const invoiceUrl = process.env.REACT_APP_TC_INVOICES_BASE_PATH;

const InvoiceTab = ({ jobId }) => {
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (jobId) fetchInvoice();
  }, [jobId]);

  const fetchInvoice = async () => {
    setLoading(true);
    try {
      if (!invoiceUrl) throw new Error("Invoice URL is not defined");
      const { data } = await apiClient.get(`${invoiceUrl}/get/${jobId}`);
      setInvoice(data?.data || null);
    } catch (error) {
      console.error("Error fetching invoice:", error);
      showErrorToast("Failed to load invoice");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <ClipLoader size={30} />
      </div>
    );
  }

  if (!invoice) {
    return (
      <div className="text-center py-4 text-muted float-start w-100">
        No invoice found for this job.
      </div>
    );
  }

  return (
    <div className="vr-inner">
      <div className="vrt-content mt-0">
        <div className="modal-graybox">
          <div className="modal-grayleft-ji mt-0">
            <h2 className="graybox-title">Invoice ID</h2>
            <p className="graybox-text">{invoice?.inv_no|| "--"}</p>
          </div>
          <div className="graybox-right invoice-grayright mt-0">
            <div className="graybox-split">
              <img src={CalenderIcon} alt="Calendar Icon" />
              <p className="contact-text">
                {invoice?.inv_datetime ? moment(invoice.inv_datetime).format(DATE_FORMAT) : "--"}
              </p>
            </div>
          </div>
        </div>

        <div className="vrt-content">
          <div className="row">
            <div className="col-md-6">
              <div className="vrt-split vrt-padding">
                <h3>Payment Status</h3>
                <p>{invoice?.paid_status === 1 ? "Paid" : "Unpaid"}</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="vrt-split vrt-padding">
                <h3>Payment Date</h3>
                <p>{invoice?.paid_datetime ? moment(invoice.paid_datetime).format(DATE_FORMAT) : "--"}</p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="vrt-split vrt-padding">
                <h3>Due Date</h3>
                <p>{invoice?.inv_due_date ? moment(invoice.inv_due_date).format(DATE_FORMAT) : "--"}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceTab;
